import { Icon } from "@trustpilot/businessapp-patternlibrary";
import { simpleArrowDown_16 as arrowDown, simpleArrowUp_16 as arrowUp } from "@trustpilot/icons";
import { calendarRangeArrow_16 as rightArrow } from "@trustpilot/icons";
import { Text } from "ilenia";

import styles from "../../styles/sideNav.module.scss";

//Render secondary navigation link and icon
const SecondaryNavLink = ({ menu, isSmall, toggleSecondary }) => (
  <span className={styles.sidebarChevron}>
    <span className={styles.sidebarLinksText}>
      {" "}
      <Text id={`Sidebar.${menu.id}`} />
    </span>
    {menu.subMenu && isSmall && (
      <span className={styles.sidebarLinksIconChevron} data-testid={`${menu.id}_secondary_nav`}>
        {!toggleSecondary && <Icon content={arrowDown} />}
        {toggleSecondary && <Icon content={arrowUp} />}
      </span>
    )}
    {!menu.subMenu && (
      <span className={styles.sidebarLinksIconChevron}>
        {" "}
        <Icon content={rightArrow} />
      </span>
    )}
  </span>
);

export default SecondaryNavLink;
